import { Action } from 'redux/actions'
import { RootState, AnonymousUser } from 'types'
import { AnonymousUserActions } from 'redux/actions/anonymousUser'

export default function reduce(state: RootState['anonymousUser'] = null, action: Action): RootState['anonymousUser'] {
  switch (action.type) {
    case AnonymousUserActions.ANONYMOUS_USER_SET: {
      return action.payload
    }

    case AnonymousUserActions.RENAME_ANONYMOUS_USER: {
      const { displayName } = action.payload
      const names = displayName.split(' ')
      const firstName = names[0]
      const lastName = names.slice(1).join(' ')
      return { ...state, display_name: displayName, first_name: firstName, last_name: lastName } as AnonymousUser
    }

    default:
      return state
  }
}
